import AgreementHasDebt from '@/components/ModalRenderer/components/AgreementHasDebt';
import BankAccountUpdateFail from '@/components/ModalRenderer/components/BankAccountUpdateFail';
import BankAccountUpdateSuccess from '@/components/ModalRenderer/components/BankAccountUpdateSuccess';
import ChangeMonthlyPaymentFailed from '@/components/ModalRenderer/components/ChangeMonthlyPaymentFailed';
import ChangeMonthlyPaymentSuccess from '@/components/ModalRenderer/components/ChangeMonthlyPaymentSuccess';
import ConfirmTerminateIdProtect from '@/components/ModalRenderer/components/ConfirmTerminateIdProtect';
import ConfirmWithdrawal from '@/components/ModalRenderer/components/ConfirmWithdrawal';
import DebtConsolidationDirectDebitMandateNotFound from '@/components/ModalRenderer/components/DebtConsolidationDirectDebitMandateNotFound';
import DepositFail from '@/components/ModalRenderer/components/DepositFail';
import DepositSuccess from '@/components/ModalRenderer/components/DepositSuccess';
import DirectDebitChargeInProgress from '@/components/ModalRenderer/components/DirectDebitChargeInProgress';
import DirectDebitConsent from '@/components/ModalRenderer/components/DirectDebitConsent';
import DirectDebitMandateNotFound from '@/components/ModalRenderer/components/DirectDebitMandateNotFound';
import DirectPaymentDetails from '@/components/ModalRenderer/components/DirectPaymentDetails';
import DirectPaymentFailed from '@/components/ModalRenderer/components/DirectPaymentFailed';
import DirectPaymentGenericError from '@/components/ModalRenderer/components/DirectPaymentGenericError';
import DirectPaymentNothingToPay from '@/components/ModalRenderer/components/DirectPaymentNothingToPay';
import DirectPaymentPaid from '@/components/ModalRenderer/components/DirectPaymentPaid';
import DirectPaymentSuccess from '@/components/ModalRenderer/components/DirectPaymentSuccess';
import LastPaybackStillProcessing from '@/components/ModalRenderer/components/LastPaybackStillProcessing';
import LevlaOfferSuccess from '@/components/ModalRenderer/components/LevlaOfferSuccess';
import NoRemainingDebt from '@/components/ModalRenderer/components/NoRemainingDebt';
import OverdueChargeInProgress from '@/components/ModalRenderer/components/OverdueChargeInProgress';
import OverduePaymentSuccess from '@/components/ModalRenderer/components/OverduePaymentSuccess';
import PaybackPlan from '@/components/ModalRenderer/components/PaybackPlan';
import PaymentFailed from '@/components/ModalRenderer/components/PaymentFailed';
import RemainingDebtInfo from '@/components/ModalRenderer/components/RemainingDebtInfo';
import RepayOutstandingBalance from '@/components/ModalRenderer/components/RepayOutstandingBalance';
import SekkiCredit from '@/components/ModalRenderer/components/SekkiCredit';
import TerminateIdProtectSuccess from '@/components/ModalRenderer/components/TerminateIdProtectSuccess';
import TermsAndConditionsModal from '@/components/ModalRenderer/components/TermsAndConditionsModal';
import TermsAndConditionsUpdated from '@/components/ModalRenderer/components/TermsAndConditionsUpdated';
import WithdrawalAmountInvalid from '@/components/ModalRenderer/components/WithdrawalAmountInvalid';
import WithdrawalBlocked from '@/components/ModalRenderer/components/WithdrawalBlocked';
import WithdrawalFail from '@/components/ModalRenderer/components/WithdrawalFail';
import WithdrawalInProgress from '@/components/ModalRenderer/components/WithdrawalInProgress';
import WithdrawalNotPossible from '@/components/ModalRenderer/components/WithdrawalNotPossible';

const Common = {
  AGREEMENT_HAS_DEBT: AgreementHasDebt,
  BANK_ACCOUNT_UPDATE_FAIL: BankAccountUpdateFail,
  BANK_ACCOUNT_UPDATE_SUCCESS: BankAccountUpdateSuccess,
  CHANGE_MONTHLY_PAYMENT_SUCCESS: ChangeMonthlyPaymentSuccess,
  CHANGE_MONTHLY_PAYMENT_FAILED: ChangeMonthlyPaymentFailed,
  CONFIRM_WITHDRAWAL: ConfirmWithdrawal,
  DEBT_CONSOLIDATION_DIRECT_DEBIT_MANDATE_NOT_FOUND: DebtConsolidationDirectDebitMandateNotFound,
  DEPOSIT_FAIL: DepositFail,
  DEPOSIT_SUCCESS: DepositSuccess,
  DIRECT_DEBIT_CHARGE_IN_PROGRESS: DirectDebitChargeInProgress,
  DIRECT_DEBIT_CONSENT: DirectDebitConsent,
  DIRECT_DEBIT_MANDATE_NOT_FOUND: DirectDebitMandateNotFound,
  DIRECT_PAYMENT_DETAILS: DirectPaymentDetails,
  DIRECT_PAYMENT_FAILED: DirectPaymentFailed,
  DIRECT_PAYMENT_GENERIC_ERROR: DirectPaymentGenericError,
  DIRECT_PAYMENT_NOTHING_TO_PAY: DirectPaymentNothingToPay,
  DIRECT_PAYMENT_PAID: DirectPaymentPaid,
  DIRECT_PAYMENT_SUCCESS: DirectPaymentSuccess,
  CONFIRM_TERMINATE_ID_PROTECT: ConfirmTerminateIdProtect,
  TERMINATE_ID_PROTECT_SUCCESS: TerminateIdProtectSuccess,
  LEVLA_OFFER_SUCCESS: LevlaOfferSuccess,
  NO_REMAINING_DEBT: NoRemainingDebt,
  OVERDUE_PAYBACKS_CHARGE_IN_PROGRESS: OverdueChargeInProgress,
  OVERDUE_PAYMENT_SUCCESS: OverduePaymentSuccess,
  PAYBACK_PLAN: PaybackPlan,
  PAYMENT_FAILED: PaymentFailed,
  REMAINING_DEBT_INFO: RemainingDebtInfo,
  REPAY_OUTSTANDING_BALANCE: RepayOutstandingBalance,
  LAST_PAYBACK_STILL_PROCESSING: LastPaybackStillProcessing,
  SEKKI_CREDIT: SekkiCredit,
  TERMS_AND_CONDITIONS: TermsAndConditionsModal,
  TERMS_AND_CONDITIONS_UPDATED: TermsAndConditionsUpdated,
  WITHDRAWAL_BLOCKED: WithdrawalBlocked,
  WITHDRAWAL_FAIL: WithdrawalFail,
  WITHDRAWAL_IN_PROGRESS: WithdrawalInProgress,
  WITHDRAWAL_NOT_POSSIBLE: WithdrawalNotPossible,
  WITHDRAWAL_AMOUNT_INVALID: WithdrawalAmountInvalid,
} as const;

export default Common;
